import Dexie, { Table } from 'dexie'

export interface Parameter {
	id?: number,
	type:string
	value?: any
	
}

export interface Menu {
	id?: number,
	key?: any,
	libelle?:any,
	url?: any,
	actions: any
	
}

export interface Dossier {
	id?: number,
	etat?: any,
	reference?: any,
	debutdate?: any,
	findate?: any,
	tiers?: any,
	suivis?: any,
	fichiers?: any,
	relations?: any,
	foyers?: any,
	formulaires?: any,
	documents?: any
}
export interface Consultation {
	id?: number,
	etat?: string,
	intervalle?: any,
	type?: string,
	groupe?: any,
	date_debut?: any
	date_fin?: any,
	domicile?: boolean,
	ponctuel?: boolean,
	lieu?: any,
	professionels?: any,
	visites?: any
}
export interface Request {
	id?: number,
	method?: string,
	params?: any,
}

export interface DocumentType {
	id?: number,
	key?: any,
	libelle?:any,
    parameter?:any
}

export const IndexedDbVersionNumber = 12;
export class NomadeDB extends Dexie {
	parameters: Table<Parameter,number>
	menus: Table<Menu, number>
	dossiers: Table<Dossier, number>
	consultations: Table<Consultation, number>
	requestes: Table<Request, number>
    documentTypes: Table<DocumentType, number>
	
	constructor() {
		super('nomade')
		this.version(IndexedDbVersionNumber).stores({
			dossiers: 'id,etat,reference,debutdate,findate,fichiers,relations,tiers,formulaires,documents,suivis',
			consultations: 'id,etat,intervalle,type,groupe,date_debut,date_fin,domicile,ponctuel,lieu,professionels,visites',
			requestes: '++id,method,params',
			menus: 'id,key,url,libelle,actions',
            documentTypes: 'id,key,libelle,parameter',
			parameters: '++id,type,value',
		})
	}
	async addItem(data: any) {
		this.getItem(data.ID).then(async v => {
			if (v) {
				this.updateItem(data)
			} else {
				await db.dossiers.add({
					id: data.ID,
					reference: JSON.stringify(data.reference || null),
					debutdate: JSON.stringify(data.debutdate || null),
					findate: JSON.stringify(data.findate || null),
					etat: JSON.stringify(data.etat || null),
					fichiers: JSON.stringify(data.fichiers || null),
					relations: JSON.stringify(data.relations || null),
					tiers: JSON.stringify(data.tiers || null),
					foyers: JSON.stringify(data.foyers || null),
					formulaires: JSON.stringify(data.formulaires || null),
					documents: JSON.stringify(data.documents || null),
					suivis: JSON.stringify(data.suivis || null)
				})
			}
		})
	}
	async addMany(dossiers: any) {
		console.log('addMany', dossiers)
		await db.dossiers.bulkAdd(
			dossiers.map((dossier: any) => ({
				reference: JSON.stringify(dossier.reference || null),
				debutdate: JSON.stringify(dossier.debutdate || null),
				findate: JSON.stringify(dossier.findate || null),
				etat: JSON.stringify(dossier.etat || null),
				fichiers: JSON.stringify(dossier.fichiers || null),
				relations: JSON.stringify(dossier.relations || null),
				tiers: JSON.stringify(dossier.tiers || null),
				foyers: JSON.stringify(dossier.foyers || null),
				formulaires: JSON.stringify(dossier.formulaires || null),
				documents: JSON.stringify(dossier.documents || null),
				suivis: JSON.stringify(dossier.suivis || null)
			}))
		)
	}
	async updateItem(data: any) {
		console.log('updateItem', data)
		await db.dossiers.update(data.ID, {
			reference: JSON.stringify(data.reference || null),
			debutdate: JSON.stringify(data.debutdate || null),
			findate: JSON.stringify(data.findate || null),
			etat: JSON.stringify(data.etat || null),
			fichiers: JSON.stringify(data.fichiers || null),
			relations: JSON.stringify(data.relations || null),
			tiers: JSON.stringify(data.tiers || null),
			foyers: JSON.stringify(data.foyers || null),
			formulaires: JSON.stringify(data.formulaires || null),
			documents: JSON.stringify(data.documents || null),
			suivis: JSON.stringify(data.suivis || null)
		})
	}
	async getItem(id: number) {
		return db.dossiers.get(id)
	}
	async addConsultation(data: any) {
		console.log(Object.keys(data), "keeeys")
		await db.consultations.add({
			id: data.ID,
			etat: JSON.stringify(data.etat || null),
			intervalle: JSON.stringify(data.intervalle || null),
			date_debut: JSON.stringify(data.date_debut || null),
			date_fin: JSON.stringify(data.date_fin || null),
			domicile: data.domicile ? data.domicile : false,
			ponctuel: data.ponctuel ? data.ponctuel : false,
			lieu: JSON.stringify(data.lieu || null),
			groupe: JSON.stringify(data.groupe),
			professionels: JSON.stringify(data.professionels || null),
			type: JSON.stringify(data.type || null),
			visites: JSON.stringify(data.visites || null)
		})
	}
	async getConsultation(id: number) {
		return db.consultations.get(id)
	}
	async updateConsultation(data: any) {
		console.log('updateConsultation', data)
		await db.consultations.update(data.ID, {
			etat: JSON.stringify(data.etat || null),
			intervalle: JSON.stringify(data.intervalle || null),
			date_debut: JSON.stringify(data.date_debut || null),
			date_fin: JSON.stringify(data.date_fin || null),
			domicile: data.domicile ? data.domicile : false,
			ponctuel: data.ponctuel ? data.ponctuel : false,
			lieu: JSON.stringify(data.lieu || null),
			groupe: JSON.stringify(data.groupe || null),
			professionels: JSON.stringify(data.professionels || null),
			type: JSON.stringify(data.type || null),
			visites: JSON.stringify(data.visites || null)
		})
	}
	async addConsultations(data: any) {
		await db.consultations.bulkAdd(
			data.map((consultation: any) => ({
				etat: JSON.stringify(consultation.etat || null),
				intervalle: JSON.stringify(consultation.intervalle || null),
				date_debut: JSON.stringify(consultation.date_debut || null),
				date_fin: JSON.stringify(consultation.date_fin || null),
				domicile: consultation.domicile ? consultation.domicile : false,
				ponctuel: consultation.ponctuel ? consultation.ponctuel : false,
				lieu: JSON.stringify(consultation.lieu || null),
				groupe: JSON.stringify(consultation.groupe || null),
				professionels: JSON.stringify(consultation.professionels || null),
				type: JSON.stringify(consultation.type || null),
				visites: JSON.stringify(consultation.visites || null)
			}))
		)
	}
    async addRequest(data: any): Promise<number> {
        const addedId = await db.requestes.add({
            method: data.method,
            params: data.params
        });
        return addedId;
    }
    
	async getRequest(id: number) {
		return db.requestes.get(id)
	}
	async updateRequest(data: any) {
		console.log('updateRequest', data)
		await db.requestes.update(data.ID, {
			params: data.params
		})
	}
	
    async deleteRequest(id: number) {
        await db.requestes.delete(id);
    }

	async updateMenu(data: any) {
		console.log('updateMenu', data)
		await db.menus.update(data.ID, {
			key: data.key,
			libelle: data.libelle,
			url: data.url,
			actions: data.actions
		})
	}
	
	async addMenu(data: any) {
		
		await db.menus.bulkAdd(
			data.map((menu: any) => ({
					id: menu.ID,
					key: menu.key,
					libelle: menu.libelle,
					url: menu.url,
					actions: JSON.stringify(menu.actions || null)
			}))
		)
		
		
	}

    async addDocumentTypes(data: any) {
        await db.documentTypes.bulkAdd(
            data.map((document: any) => ({
                id: document.ID,
                key: document.type.key,
                libelle: document.type.libelle,
                parameter: document.parameter
            }))
        );
    }
    
	async addParameter(type: string,value:any): Promise<number> {
	       const addedId = await db.parameters.add(
	          { type:type,
				value:value
				}
	            
	        );
		 return  addedId
	       
	}

}

export const db = new NomadeDB()
